<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between" @click="selectTeam(object.idTeam)">
      <div><span style="opacity: 0.5">idTeam - </span><b> name </b></div>
      <div>
        <div>
          <TheChip class="text-center me-2" text="Meta Pontos Atingida" color="bg-success mx-1" />
          <TheChip class="text-center me-2" text="Meta Pontos Não Definida" color="bg-warning mx-1" />
          <TheChip class="text-center me-2" :text="'Meta Pontos não Atingida'" color="bg-red mx-1" />
          <i
            :class="filterToggle ? 'bi bi-chevron-up icon h4' : 'bi bi-chevron-down icon h4'"
            @click="toggleFilter"></i>
        </div>
      </div>
    </div>

    <TheTransition>
      <div v-if="filterToggle">
        <div class="row">
          <div class="col-9">
            <div class="card-body">
              <div class="row">
                <div class="col-2 mb-3">
                  <span style="opacity: 0.5" class="me-2">{{ `Mão Obra: ` }}</span
                  ><br />
                  <b>{{ formatMoneyS(100) }}</b
                  ><br />
                </div>
                <div class="col-2 mb-3">
                  <span style="opacity: 0.5" class="me-2">{{ `Veículos: ` }}</span
                  ><br />
                  <b>{{ formatMoneyS(100) }}</b
                  ><br />
                </div>
                <div class="col-2 mb-3">
                  <span style="opacity: 0.5" class="me-2">{{ `EQ. Leves: ` }}</span
                  ><br />
                  <b>{{ formatMoneyS(100) }}</b
                  ><br />
                </div>
                <div class="col-2 mb-3">
                  <span style="opacity: 0.5" class="me-2">{{ `Combs: ` }}</span
                  ><br />
                  <b>{{ formatMoneyS(100) }}</b
                  ><br />
                </div>
                <div class="col-2 mb-3">
                  <span style="opacity: 0.5" class="me-2">{{ `Base: ` }}</span
                  ><br />
                  <b>{{ formatMoneyS(100) }}</b
                  ><br />
                </div>
              </div>

              <div class="row bold ms-1 me-1">
                <div class="col-4" v-for="(card, index) in cards" :key="index">
                  <h6>
                    <TheKPICard
                      :color="card.class"
                      :value="formatTotal(card.total)"
                      :title="card.title"
                      :tooltipText="card.tooltipText"
                      tamanhoH1="h3" />
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 align-items-center text-white custom-mt" :key="index">
            <TheKPICard
              color="m-card"
              :value="formatMoneyS(100)"
              title="Valor Medido"
              tooltipText="Valor medido com base nas ordens de serviço medidas e validadas pela sanepar"
              :objetivo="formatMoneyS(100)"
              @click="showModal = true"
              tamanhoH1="h2" />
          </div>
        </div>

        <div class="card-header d-flex justify-content-between">
          <div>
            <b>PROTOCOLOS</b>
          </div>
          <div>
            <i
              :class="filterProtocol ? 'bi bi-chevron-up icon h4' : 'bi bi-chevron-down icon h4'"
              @click="toggleProtocol"></i>
          </div>
        </div>

        <TheTable
          :headers="headers"
          :actualPage="page"
          :items="itemsProtocol"
          v-if="filterProtocol"
          :totalPages="pages"
          v-model="actualPage">
          <template v-slot:protocolo="{ item }">
            <div class="text-center details">
              {{ item.protocolo }}
            </div>
          </template>

          <template v-slot:performedDate="{ item }">
            <div class="text-center">
              {{ formatDate(item.performedDate) }}
            </div>
          </template>
        </TheTable>
      </div>
    </TheTransition>
  </div>
</template>

<script>
import { search } from '@/crud.js'
import { useFormat } from '@/composables/useFormat'

const { formatDate, formatMoneyS } = useFormat()

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    date: {
      type: Object,
    },
    check: false,
  },

  data: () => ({
    filterToggle: false,

    pages: null,
    page: 0,
    actualPage: 1,
    limit: 20,

    selectedTeam: null,
    filterProtocol: false,
    showModal: false,
    points: null,
    items: [],
    itemsProtocol: [],
    headers: [
      { title: 'Protocolo', field: 'protocolo' },
      { title: 'Serviço', field: 'idServiceRequested', align: 'text-center' },
      { title: 'Equipe', field: 'idTeam', align: 'text-center' },
      { title: 'Data', field: 'performedDate' },
    ],
    cards: [
      {
        class: 't-cards',
        title: 'Custo Total',
        total: 'totalValue',
        tooltipText:
          'Soma de todo o custo total de todos os funcionários. Isso representa  (Salário + Encargos + VR + VA + VT + SV + Uniformes + EPI + Auxilio)',
      },
      {
        class: 't-cards',
        title: 'Meta Mensal',
        total: 'dailyMeta',
        tooltipText: 'Meta mensal por equipe em reais.',
      },
      {
        class: 't-cards',
        title: 'Total de pontos',
        total: 'points',
        tooltipText: 'Pontuação da Equipe',
      },
    ],
  }),

  methods: {
    formatDate,
    formatMoneyS,
    async searchItems(page = 1, idTeam) {
      if (this.date) {
        const params = {
          page: page,
          limit: this.limit,
          idTeam: idTeam,
        }

        if (typeof this.date === 'string') {
          params.startDate = this.date
          params.endDate = this.date
        } else {
          params.startDate = this.date[0]
          params.endDate = this.date[1]
        }

        const raw = await search(`osMedicao`, params)
        this.itemsProtocol = raw.data
        this.pages = Math.ceil(raw.total / this.limit)
      } else {
        this.modalBody = 'É necessário informar uma data de vigência !'
        this.modalError.show()
      }
    },

    selectTeam(idTeam) {
      this.selectedTeam = idTeam
      this.searchItems(1, idTeam)
    },

    toggleFilter() {
      this.filterToggle = !this.filterToggle
    },

    toggleProtocol() {
      this.filterProtocol = !this.filterProtocol
    },

    formatTotal(key) {
      if (key === 'totalValue') {
        return formatMoneyS(this.object.totalValue)
      } else if (key === 'totalIndireto') {
        return formatMoneyS(this.object.totalIndireto)
      } else if (key === 'dailyMeta') {
        return formatMoneyS(this.object.dailyMeta)
      } else if (key === 'points') {
        return this.object[key] ? this.object[key].totalPoints : 0
      } else {
        return this.object[key]
      }
    },
  },

  watch: {
    check() {
      this.filterToggle = this.check
    },
    checkP() {
      this.filterProtocol = this.checkP
    },
    actualPage() {
      this.searchItems(this.actualPage, this.object.idTeam)
    },
  },
}
</script>

<style>
.icon {
  cursor: pointer;
}

.t-cards {
  border: none;
  border-radius: 15px;
  background: rgb(132, 245, 222);
  background: linear-gradient(-115deg, rgba(132, 245, 222, 1) 0%, rgba(76, 197, 248, 1) 100%);
}

.m-card {
  border: none;
  border-radius: 15px;
  background: rgb(63, 187, 254);
  background: linear-gradient(-115deg, rgba(63, 187, 254, 1) 0%, rgba(165, 65, 255, 1) 100%);
}

.custom-mt {
  margin-top: 45px;
  padding-right: 30px;
}
</style>
